const PartnersSection = () => {
  const partners = [
    // Row 1
    { id: 1, name: 'Tanzania Government', logo: '/assets/partners/1.png' },
    { id: 2, name: 'Serengeti Bytes', logo: '/assets/partners/2.jpeg' },
    { id: 3, name: 'Bahwan Cybertek', logo: '/assets/partners/3.jpg' },
    { id: 4, name: 'UDSM', logo: '/assets/partners/4.png' },
    { id: 5, name: 'European Union', logo: '/assets/partners/5.PNG' },
    { id: 6, name: 'Enabel', logo: '/assets/partners/6.png' },
    { id: 7, name: 'FUNGUO Programme', logo: '/assets/partners/7.jpg' },
    { id: 8, name: 'UK International Development', logo: '/assets/partners/8.jpg' },
    // Row 2
    { id: 9, name: 'UN Women', logo: '/assets/partners/9.png' },
    { id: 10, name: 'DAT', logo: '/assets/partners/10.jpg' },
    { id: 11, name: 'UNDP', logo: '/assets/partners/11.png' },
    { id: 12, name: 'UNICEF', logo: '/assets/partners/12.PNG' },
    { id: 13, name: 'UNCDF', logo: '/assets/partners/13.png' },
    { id: 14, name: 'Innovation Week Tanzania', logo: '/assets/partners/14.png' }
  ];

  return (
    <section className="py-12 md:py-24 bg-white" style={{ backgroundColor: '#ffffff', padding: '3rem 0' }}>
      <div className="container mx-auto px-6 md:px-8 lg:px-12" style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16" style={{ marginBottom: '3rem' }}>
          <h2 
            className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-3 md:mb-4 uppercase" 
            style={{ 
              fontSize: 'clamp(1.875rem, 4vw, 3rem)', 
              fontWeight: '700', 
              color: '#1f2937',
              marginBottom: '0.75rem',
              letterSpacing: '0.05em'
            }}
          >
            OUR PARTNERS
          </h2>
          <p 
            className="text-gray-700 text-sm md:text-lg font-medium uppercase tracking-wide" 
            style={{ 
              color: '#374151', 
              fontSize: 'clamp(0.875rem, 2vw, 0.95rem)',
              fontWeight: '600',
              letterSpacing: '0.1em',
              textTransform: 'uppercase'
            }}
          >
            Uniting with Visionary Organizations to Transform Tanzania's Digital Landscape
          </p>
        </div>

        {/* Partners Grid */}
        <div 
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 md:gap-8 items-center justify-items-center"
          style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
            gap: '1rem 1.5rem',
            alignItems: 'center',
            justifyItems: 'center',
            marginLeft: '0',
            marginRight: '0',
            padding: '0 1rem'
          }}
        >
          {partners.map((partner) => (
            <div 
              key={partner.id} 
              className="partner-logo-container group"
              style={{
                width: '100%',
                maxWidth: '140px',
                height: '80px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0.75rem'
              }}
            >
              <img 
                src={partner.logo} 
                alt={partner.name}
                className="partner-logo transition-all duration-300"
                style={{ 
                  maxWidth: '100%',
                  maxHeight: '100%',
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                  filter: 'grayscale(0%)',
                  opacity: '0.9',
                  transition: 'all 0.3s ease'
                }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                }}
                onMouseEnter={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.opacity = '1';
                  target.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.opacity = '0.9';
                  target.style.transform = 'scale(1)';
                }}
              />
            </div>
          ))}
        </div>

        {/* Optional: Add a call to action */}
        <div className="text-center mt-16" style={{ marginTop: '4rem' }}>
          <p className="text-gray-600 text-lg mb-6" style={{ color: '#6b7280', fontSize: '1.125rem', marginBottom: '1.5rem' }}>
            Interested in partnering with us?
          </p>
          <a 
            href="/contact" 
            className="inline-flex items-center px-8 py-4 bg-blue-900 text-white rounded-full font-semibold text-lg hover:bg-blue-800 transition-colors duration-300 group"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              padding: '1rem 2rem',
              backgroundColor: '#0f1b3c',
              color: 'white',
              borderRadius: '9999px',
              fontWeight: '600',
              fontSize: '1.125rem',
              textDecoration: 'none',
              transition: 'background-color 0.3s ease'
            }}
          >
            Get in Touch
            <i className="fa-solid fa-arrow-right ml-3 group-hover:translate-x-1 transition-transform duration-300" style={{ marginLeft: '0.75rem' }}></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
